var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ConfirmDropComponent } from './../confirm-drop/confirm-drop.component';
import { MyteamsService } from './../_services/myteams.service';
import { OnInit, OnDestroy, ElementRef, QueryList } from '@angular/core';
import { Playerinfobox2Component } from 'src/app/playerinfobox2/playerinfobox2.component';
import { TournamentpopupComponent } from './../tournamentpopup/tournamentpopup.component';
import { GamepreviewpopupComponent } from './../gamepreviewpopup/gamepreviewpopup.component';
import { WeekMetrixComponent } from './../weekMetrix/weekMetrix.component';
import { SwapPlayersComponent } from './../swapPlayers/swapPlayers.component';
import { MatchupComponent } from './../matchup/matchup.component';
import { Store } from '@ngrx/store';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material';
import html2canvas from './../../../node_modules/html2canvas/dist/html2canvas.min.js';
import { MainService } from '../_services/main.service';
import { ResultboardService } from '../resultboard/resultboard.service';
import { Router } from '@angular/router';
import { MultiSwapPlayersComponent } from '../multiSwapPlayers/multiSwapPlayers.component';
import { ConfirmboxComponent } from 'src/app/confirmbox/confirmbox.component';
import { TournamentService } from 'src/app/tournamentpopup/tournament.service';
import { UserBalanceData } from './../store/actions/appActions';
var MyteamsComponent = /** @class */ (function () {
    function MyteamsComponent(store, dialog, _mainService, _myTeamsService, _resultboardService, router, tournamentService) {
        var _this = this;
        this.store = store;
        this.dialog = dialog;
        this._mainService = _mainService;
        this._myTeamsService = _myTeamsService;
        this._resultboardService = _resultboardService;
        this.router = router;
        this.tournamentService = tournamentService;
        this.displayActiveContests = [];
        this.siteurl = "" + environment.SITE_URL;
        this.isMobile = false;
        this.user = null;
        this.lgIndex = 0;
        this.tIndex = 0;
        this.mobileTabsIndex = 0;
        this.contestSearch = ''; // search string for contest filter
        this.searchTimer = null;
        this.standingsIndex = 0;
        this.preStandingsScroll = 0;
        this.moreRegular = false;
        this.moreTour = false;
        this.myEntries = false;
        this.initialLoad = true;
        this.doLiveUpdate = true;
        this.mrFullStandings = false;
        this.currentTab = 'live'; // upcoming, live, history
        this.contestFilters = 'all'; // all, cash, tournament, season
        this.currentOrder = 'asc';
        this.currentSort = "";
        this.showCanvasSS = false;
        this.allImgsArray = [];
        this.imageData = {};
        this.request_left = 0;
        this.showStandings = false;
        this.standingsLoading = true;
        this.standingsLoadMore = false;
        this.showPlayers = true;
        this.loadingMore = false;
        this.loadingContests = true;
        this.isLoading = true;
        this.updateTimer = null;
        this.leftScroll = 0;
        this.contests = [];
        this.displayContests = [];
        this.standings = [];
        this.contest = {};
        this.currentDisplay = 'both'; // left, right, both
        this.bucketURL = environment.assetURL + "/assets/default/images/";
        this.playerURL = environment.assetURL + "/assets/uploads/players/";
        this.playerImgFolder = "assets/uploads/players/";
        this.logoUrl = 'assets/default/images/logo-red.png';
        this.logoUrlDark = 'assets/default/images/logo.png';
        this.isMac = false;
        this.games = {
            0: 'all',
            1: 'nhl',
            2: 'nfl',
            3: 'mlb',
            4: 'nba',
            5: 'pga'
        };
        this.curGame = '0';
        this.lgId = 0;
        this.tourId = 0;
        this.darkMode = false;
        this.browsername = '';
        this.darkMode_ext = '';
        this.errorMsg = '';
        this.errorMsg2 = '';
        this.imgversion = '1.1115';
        this.showLgBoard = false;
        this.seasonList = [];
        this.selectedSeason = 0;
        // hard-coded stat name translations for display
        this.stats = {
            'sppt': { priority: 217, name: 'PPT' },
            'stoi': { priority: 216, name: 'TOI' },
            'gppt': { priority: 261, name: 'TOI' },
            'gso': { priority: 258, name: 'SO' },
            'gga': { priority: 257, name: 'GA' },
            'gsa': { priority: 256, name: 'SA' },
            'gs': { priority: 255, name: 'S' },
            'gotl': { priority: 254, name: 'OT' },
            'gl': { priority: 253, name: 'Loss' },
            'gw': { priority: 252, name: 'W' },
            'ggs': { priority: 251, name: 'GS' },
            'sh': { priority: 215, name: 'HT' },
            'sfol': { priority: 214, name: 'FOL' },
            'sfow': { priority: 213, name: 'FOW' },
            'spm': { priority: 212, name: 'PIM' },
            'sbs': { priority: 211, name: 'BS' },
            'ssog': { priority: 210, name: 'SOG' },
            'ssha': { priority: 209, name: 'SHA' },
            'sshg': { priority: 208, name: 'SHG' },
            'sppp': { priority: 207, name: 'PPP' },
            'sppa': { priority: 206, name: 'PPA' },
            'sppg': { priority: 205, name: 'PPG' },
            'sp_minus': { priority: 204, name: '+/-' },
            'sp': { priority: 203, name: 'P' },
            'sa': { priority: 202, name: 'A' },
            'sg': { priority: 201, name: 'G' },
            'ggaa': { priority: 262, name: 'GAA' },
            'gsp': { priority: 263, name: '%' },
            'patt': { priority: 101, name: 'ATT' },
            'comp': { priority: 102, name: 'COMP' },
            'pyrd': { priority: 103, name: 'YDS' },
            'ptd': { priority: 104, name: 'TD' },
            'inth': { priority: 105, name: 'Int' },
            'p2pc': { priority: 107, name: '2pt' },
            'ratt': { priority: 108, name: 'Att' },
            'ryrd': { priority: 109, name: 'RYds' },
            'rtd': { priority: 110, name: 'TD' },
            'rcp': { priority: 112, name: 'Rec' },
            'rcyrd': { priority: 113, name: 'RecYds' },
            'rctd': { priority: 114, name: 'TD' },
            'ofmrt': { priority: 117, name: 'TD' },
            'kort': { priority: 119, name: 'TD' },
            'prtd': { priority: 120, name: 'TD' },
            'fmb': { priority: 121, name: 'Fum' },
            'fmbl': { priority: 122, name: 'FumL' },
            '2pc': { priority: 123, name: '2pt' },
            'piy': { priority: 124, name: 'PIY' },
            'fg19y': { priority: 125, name: '1-19' },
            'fg29y': { priority: 126, name: '20-29' },
            'fg39y': { priority: 127, name: '30-39' },
            'fg49y': { priority: 128, name: '40-49' },
            'fg50y': { priority: 129, name: '50+' },
            'fgm': { priority: 130, name: 'FGM' },
            'fgms': { priority: 131, name: 'MISS' },
            'paam': { priority: 132, name: 'XPM' },
            'paams': { priority: 133, name: 'MISS' },
            'pa0': { priority: 134, name: 'PA' },
            'pa6': { priority: 135, name: 'PA' },
            'pa13': { priority: 136, name: 'PA' },
            'pa20': { priority: 137, name: 'PA' },
            'pa27': { priority: 138, name: 'PA' },
            'pa34': { priority: 139, name: 'PA' },
            'pa35': { priority: 140, name: 'PA' },
            'sck': { priority: 141, name: 'Sck' },
            'irt': { priority: 142, name: 'TD' },
            'intr': { priority: 143, name: 'Int' },
            'fmry': { priority: 145, name: 'FumR' },
            'ofrt': { priority: 146, name: 'TD' },
            'mfgrt': { priority: 147, name: 'TD' },
            'bprt': { priority: 148, name: 'TD' },
            'bfgrt': { priority: 149, name: 'TD' },
            'blckk': { priority: 150, name: 'Blk' },
            'xpm': { priority: 151, name: 'XPM' },
            'miss': { priority: 152, name: 'MISS' },
            'hitbat': { priority: 300, name: 'AB' },
            'hitrns': { priority: 301, name: 'R' },
            'hithts': { priority: 302, name: 'H' },
            'hitssingle': { priority: 303, name: '1B' },
            'hitdbl': { priority: 304, name: '2B' },
            'hittrpl': { priority: 305, name: '3B' },
            'hithrns': { priority: 306, name: 'HR' },
            'hitrnsbat': { priority: 307, name: 'RBI' },
            'hitwlks': { priority: 308, name: 'BB' },
            'hithtsbp': { priority: 309, name: 'HBP' },
            'hitstrkout': { priority: 310, name: 'SO' },
            'hitstolnbas': { priority: 311, name: 'SB' },
            'hitcs': { priority: 312, name: 'CS' },
            'hitsac': { priority: 313, name: 'SAC' },
            'hitgdp': { priority: 314, name: 'GDP' },
            'pitchinnp': { priority: 315, name: 'IP' },
            'pitchwin': { priority: 316, name: 'W' },
            'pitchloses': { priority: 317, name: 'L' },
            'pitchsv': { priority: 318, name: 'SV' },
            'pitchbsv': { priority: 319, name: 'BSV' },
            'pitchstrkout': { priority: 320, name: 'SO' },
            'pitchhts': { priority: 321, name: 'H' },
            'pitchrnsern': { priority: 322, name: 'ER' },
            'pitchallowrun': { priority: 323, name: 'HR' },
            'pitchallowwalk': { priority: 324, name: 'BB' },
            'pitchhitbatsman': { priority: 325, name: 'HB' },
            'pitchwildpitch': { priority: 326, name: 'WP' },
            'pitchbalks': { priority: 327, name: 'BK' },
            'pitchstnlagainst': { priority: 328, name: 'SB' },
            'pitchbaserunner': { priority: 329, name: 'PO' },
            'pitchgdp': { priority: 330, name: 'GDP' },
            'pitchcg': { priority: 331, name: 'CG' },
            'pitchsho': { priority: 332, name: 'SHO' },
            'pitchno': { priority: 333, name: 'NH' },
            'pitchpg': { priority: 334, name: 'PG' },
            'hitavg': { priority: 335, name: 'AVG' },
            'hitobp': { priority: 336, name: 'OBP' },
            'hitslg': { priority: 337, name: 'SLG' },
            'hitops': { priority: 338, name: 'OPS' },
            'pitchera': { priority: 339, name: 'ERA' },
            'pitchwhip': { priority: 340, name: 'WHIP' },
            'hitsout': { priority: 341, name: 'K' },
            'pitchsout': { priority: 342, name: 'K' },
            'hitssacfl': { priority: 343, name: 'SAC' },
            'hitstobase': { priority: 340, name: 'BAS' },
            'defit': { priority: 144, name: 'TD' },
            'nbgs': { priority: 408, name: 'GS' },
            'nbmin': { priority: 400, name: 'MIN' },
            'nbpts': { priority: 401, name: 'PTS' },
            'nb3pm': { priority: 402, name: '3PM' },
            'nbreb': { priority: 405, name: 'REB' },
            'nboreb': { priority: 410, name: 'OREB' },
            'nbdreb': { priority: 411, name: 'DREB' },
            'nbass': { priority: 403, name: 'A' },
            'nbstl': { priority: 407, name: 'STL' },
            'nbblk': { priority: 406, name: 'BLK' },
            'nbmiss': { priority: 412, name: 'MISS' },
            'nbto': { priority: 404, name: 'TO' },
            'nbpm': { priority: 413, name: '+/-' },
            'sog': { priority: 218, name: 'OG' },
            'place': { priority: 414, name: 'Place' },
            'alb': { priority: 415, name: 'ALB' },
            'eag': { priority: 416, name: 'EAG' },
            'bir': { priority: 417, name: 'BIR' },
            'par': { priority: 418, name: 'PAR' },
            'bog': { priority: 419, name: 'BOG' },
            'dbog': { priority: 420, name: 'DBOG' },
            'other': { priority: 421, name: 'OTH' },
            'p1': { priority: 422, name: 'P1' },
            'p2': { priority: 423, name: 'P2' },
            'p3': { priority: 424, name: 'P3' },
            'p4': { priority: 425, name: 'P4' },
            'p5': { priority: 426, name: 'P5' },
            'p6': { priority: 427, name: 'P6' },
            'p7': { priority: 428, name: 'P7' },
            'p8': { priority: 429, name: 'P8' },
            'p9': { priority: 430, name: 'P9' },
            'p10': { priority: 431, name: 'P10' },
            'p11t15': { priority: 432, name: 'P11-15' },
            'p16t20': { priority: 433, name: 'P16-20' },
            'p21t25': { priority: 434, name: 'P21-25' },
            'p26t30': { priority: 435, name: 'P26-30' },
            'p31t40': { priority: 436, name: 'P31-40' },
            'p41t50': { priority: 437, name: 'P41-50' },
            'sft': { priority: 153, name: 'Sft' }
        };
        // hard-coded position translations for display
        this.positions = {
            'FLEX': 'FX',
            'UTIL': 'UT',
            'WR-TE': 'WT',
            'SFLEX': 'SF',
            'DEF': 'D'
        };
        if (navigator.appVersion.indexOf("Mac") != -1)
            this.isMac = true;
        if (navigator.userAgent.match(/AppleWebKit/) && !navigator.userAgent.match(/Chrome/)) {
            this.browsername = 'safaribrowser';
        }
        this.store.select('authData').subscribe(function (state) {
            if (state[0]) {
                _this.user = state[0];
                if (_this.curGame != null)
                    _this.loadContests();
            }
        });
        this.sub_isMobileScreen = this.store.select('isMobileScreen').subscribe(function (state) {
            if (state.length > 0) {
                _this.isMobile = state[0];
                if (_this.isMobile && _this.currentDisplay == 'both') {
                    if (_this.contest.status == null) {
                        _this.currentDisplay = 'left';
                    }
                    else {
                        _this.currentDisplay = 'right';
                    }
                }
                else if (!_this.isMobile) {
                    _this.currentDisplay = 'both';
                }
                if (_this.isMobile) {
                    setTimeout(function () {
                        _this.setupListeners('init');
                    }, 500);
                }
            }
        });
        // this.sub_currentGame = this._lobbyService.cgObservable.subscribe(state => {
        //   if (state.game != null && this.curGame != state.game && !(this.curGame == 0 && state.game == 'all')) {
        //     this.curGame = (state.game == 'all') ? 0 : parseInt(state.game);
        //     if (this.user != null) {
        //       this.lgIndex = 0;
        //       this.tIndex = 0;
        //       this.contests = [];
        //       this.loadingContests = true;
        //       this.leftSide.nativeElement.scrollTop = 0;
        //       this.loadContests();
        //     }
        //   }
        // });
        // live updates
        this.updateTimer = setInterval(function () {
            _this.updateContests();
        }, 60000);
        this.store.select('DarkModeReducer').subscribe(function (state) {
            if (state.length > 0) {
                _this.darkMode = state[0].isDarkMode;
                _this.darkMode_ext = _this.darkMode ? '-dark' : '';
            }
        });
    }
    MyteamsComponent.prototype.ngOnInit = function () {
    };
    MyteamsComponent.prototype.ngOnDestroy = function () {
        clearInterval(this.updateTimer);
        if (this.activeDraftListener)
            this.activeDraftListener.unsubscribe();
        if (this.newLeague)
            this.newLeague.unsubscribe();
        if (this.pickChanges)
            this.pickChanges.unsubscribe();
    };
    MyteamsComponent.prototype.loadContests = function (callback) {
        var _this = this;
        if (callback === void 0) { callback = null; }
        this.loadingMore = true;
        var season = this.selectedSeason || 0;
        this._myTeamsService.getContestListing(this.user.id, this.contestFilters, this.lgIndex, this.tIndex, this.currentTab, this.curGame, this.showPlayers, (this.contestSearch == '') ? null : this.contestSearch, (this.currentTab != "history") ? null : season).subscribe(function (res) {
            if (res.status == 'success') {
                if (!res.contests.length && _this.initialLoad) {
                    _this.currentTab = 'history';
                    _this.initialLoad = false;
                    _this.loadContests();
                }
                // parse results
                if (_this.lgIndex == 0 && _this.tIndex == 0) {
                    _this.contests = res.contests;
                }
                else {
                    _this.contests = _this.contests.concat(res.contests);
                }
                _this.displayContests = _this.contests;
                _this.initialLoad = false;
                _this.lgIndex = res.lgIndex;
                _this.tIndex = res.tIndex;
                _this.moreRegular = res.moreRegular;
                _this.moreTour = res.moreTour;
                _this.loadingMore = false;
                if (!_this.isMobile && _this.contest.status == null && _this.contests.length) {
                    if (_this.contests[0].type == 'league') {
                        _this.loadContest(_this.contests[0].slug);
                    }
                    else if (_this.contests[0].type == 'tournament') {
                        _this.expandTour(_this.contests[0], function () {
                            if (_this.contests[0].lgms.length) {
                                _this.loadContest(_this.contests[0].lgms[0].slug);
                            }
                        });
                    }
                    else {
                        _this.isLoading = false;
                    }
                }
                else {
                    _this.isLoading = false;
                }
                if (callback != null)
                    callback();
            }
            else {
                _this.isLoading = false;
            }
            _this.loadingContests = false;
        });
    };
    MyteamsComponent.prototype.getSeasonList = function () {
        var _this = this;
        this._myTeamsService.getSeasonList().subscribe(function (res) {
            if (res.status == 'success') {
                _this.seasonList = res && res.entities ? res.entities : [];
            }
        });
    };
    MyteamsComponent.prototype.getHeight = function (element) {
        var top = element.getBoundingClientRect().top;
        var wH = window.innerHeight;
        return wH - top - ((this.isMobile) ? 70 : 10);
    };
    MyteamsComponent.prototype.contestsReset = function () {
        this.currentSort = null;
        this.lgIndex = 0;
        this.tIndex = 0;
        this.leftSide.nativeElement.scrollTop = 0;
        this.contests = [];
        this.displayContests = [];
        this.loadingContests = true;
        this.loadContests();
    };
    MyteamsComponent.prototype.tabChange = function (event) {
        this.currentTab = event;
        if (this.currentTab == 'history')
            this.getSeasonList();
        if (this.currentTab == 'drafting') {
            this.displayContests = [];
            this.setupListeners('change');
        }
        else {
            this.contestsReset();
        }
    };
    MyteamsComponent.prototype.toggleDisplay = function () {
        var _this = this;
        switch (this.currentDisplay) {
            case 'both':
                this.currentDisplay = 'left';
                break;
            case 'left':
                this.currentDisplay = 'right';
                break;
            case 'right':
                this.currentDisplay = 'both';
                setTimeout(function () {
                    _this.leftSide.nativeElement.scrollTop = _this.leftScroll;
                }, 50);
                break;
        }
        ;
    };
    MyteamsComponent.prototype.getPMRStyle = function (pmr, total) {
        var percentage = Math.floor((pmr / total) * 100);
        var color = 'rgb(15,140,30)';
        if (percentage < 60)
            color = 'rgb(220,220,40)';
        if (percentage < 25)
            color = 'rgb(200,25,25)';
        return {
            'width': percentage + "%",
            'background-color': color
        };
    };
    MyteamsComponent.prototype.contestScroll = function (event) {
        this.leftScroll = event.target.scrollTop;
        if (!this.loadingMore) {
            var top_1 = event.target.scrollTop + event.target.clientHeight;
            var height = event.target.scrollHeight;
            var saved_1 = event.target.scrollTop;
            if (top_1 > height - 10) {
                // load more
                if (this.moreRegular || this.moreTour)
                    this.loadContests(function () {
                        event.target.scrollTop = saved_1;
                    });
            }
        }
    };
    MyteamsComponent.prototype.loadContest = function (slug, isStandings, isMove) {
        var _this = this;
        if (isStandings === void 0) { isStandings = false; }
        if (isMove === void 0) { isMove = false; }
        this.showLgBoard = false;
        if (this.contest.status == null || this.contest.data.slug == null || this.contest.data.slug != slug || isMove || this.isMobile) {
            this.isLoading = true;
            this.doLiveUpdate = true;
            if (!isStandings)
                this.myEntries = false;
            this.displayContests.forEach(function (c) {
                c.selected = (c.slug == slug);
            });
            // if (!this.isMobile) this.preStandingsScroll = this.leftScroll;
            if (this.currentDisplay == 'left') {
                this.currentDisplay = (this.isMobile) ? 'right' : 'both';
            }
            this._myTeamsService.getContestPlayers(slug, 0, 0, this.selectedSeason).subscribe(function (res) {
                if (res.status == true) {
                    if (!isStandings)
                        _this.contest = {};
                    _this.contest.status = 'success';
                    _this.contest.data = res.entities;
                    if (_this.contest.data.draft_type == 4)
                        _this.contest.data.players.sort(function (a, b) { return b.pn - a.pn; });
                    if (_this.currentDisplay != 'both') {
                        _this.showStandings = false;
                        _this.mobileTabsIndex = 0;
                    }
                    else {
                        if (_this.contest.data.duration_id == 8) {
                            _this.showStandings = true;
                        }
                        else {
                            var swapEnabled = _this.contest.data.players.filter(function (element) { return element.is_swap == 1 || element.is_move == 1 || element.swap_cnf == 1 || element.move_undo == 1 || element.move_cnf == 1 || element.move_swap == 1; });
                            if (swapEnabled.length > 0) {
                                _this.showStandings = false;
                            }
                            else {
                                _this.showStandings = true;
                            }
                        }
                    }
                    if (_this.contest.data.weekSlider != null && _this.contest.data.weekSlider.length) {
                        var selected = _this.contest.data.weekSlider.filter(function (w) { return w.selected == 1; })[0];
                        if (selected == null)
                            selected = _this.contest.data.weekSlider[0];
                        _this.contest.data.selectedWeek = selected.value;
                    }
                    _this.contest.data.players.forEach(function (p) { return _this.createStatsArray(p, _this.contest.data); });
                    _this.getURL(_this.contest.data.players);
                    var currentTime = (new Date()).getTime() / 1000;
                    var defaultDisplay = (_this.contest.data.duration_id == 8 && _this.contest.data.egs < currentTime) ? true : false;
                    if (!_this.isMobile && !_this.showStandings && defaultDisplay == true)
                        _this.startStandings();
                }
                else {
                    _this.contest = {};
                }
                _this.isLoading = false;
            });
        }
        else {
            if (this.currentDisplay != 'both') {
                this.showStandings = false;
                this.mobileTabsIndex = 0;
            }
        }
    };
    MyteamsComponent.prototype.prettyEnd = function (value) {
        if (value % 100 > 10 && value % 100 < 14) {
            return 'th';
        }
        else {
            switch (value % 10) {
                case 1:
                    return 'st';
                    break;
                case 2:
                    return 'nd';
                    break;
                case 3:
                    return 'rd';
                    break;
                default:
                    return 'th';
                    break;
            }
            ;
        }
    };
    MyteamsComponent.prototype.expandTour = function (contest, callback) {
        if (callback === void 0) { callback = null; }
        contest.loading = true;
        if (contest.type == 'tournament' && contest.lgm_ids.length && (contest.lgms == null || !contest.lgms.length)) {
            this._myTeamsService.expandTour(contest.lgm_ids, this.contestSearch, this.selectedSeason).subscribe(function (res) {
                // console.log(res);
                if (res.status == 'success' && res.contests.length) {
                    if (res.contests[0]._tour_id > 0 && res.contests[0].is_gpp == 'N') {
                        // locally filter out old round entries
                        // sort desc by round_id
                        res.contests.sort(function (a, b) { return b.round_id - a.round_id; });
                        var used_1 = {};
                        // only add team_name once
                        contest.lgms = [];
                        res.contests.forEach(function (c) {
                            if (used_1[c.team_name] == null) {
                                used_1[c.team_name] = 1;
                                contest.lgms.push(c);
                            }
                        });
                        // sort back to rank asc
                        contest.lgms.sort(function (a, b) { return a.team_rank - b.team_rank; });
                    }
                    else {
                        contest.lgms = res.contests;
                    }
                    contest.loading = false;
                    contest.expanded = true;
                    if (callback != null)
                        callback();
                }
            });
        }
    };
    MyteamsComponent.prototype.startStandings = function () {
        this.mobileTabsIndex = 1;
        this.preStandingsScroll = this.leftScroll;
        this.showStandings = true;
    };
    MyteamsComponent.prototype.toggleStandings = function () {
        var _this = this;
        if (!this.showStandings) {
            this.startStandings();
        }
        else {
            this.mobileTabsIndex = 0;
            this.showStandings = false;
            if (!this.isMobile)
                this.currentDisplay = 'left';
            setTimeout(function () {
                _this.leftSide.nativeElement.scrollTop = _this.preStandingsScroll;
            }, 150);
        }
    };
    MyteamsComponent.prototype.standingsOff = function () {
        var _this = this;
        if (this.showStandings) {
            this.mobileTabsIndex = 0;
            this.showStandings = false;
            if (!this.isMobile)
                this.currentDisplay = 'left';
            setTimeout(function () {
                _this.leftSide.nativeElement.scrollTop = _this.preStandingsScroll;
            }, 150);
        }
    };
    MyteamsComponent.prototype.openPlayerInfoBox = function (player, player_id, e) {
        e.preventDefault();
        e.stopPropagation();
        if ((player.infobox == null || player.infobox == 1) && player_id) {
            this.dialog.open(Playerinfobox2Component, {
                width: (this.isMobile) ? '90%' : '70%',
                height: 'auto',
                autoFocus: false,
                data: {
                    isDraft: false,
                    league: {
                        game_id: this.contest.data.game_id,
                        id: this.contest.data.league_id,
                        abbr: this.games[this.contest.data.game_id],
                        active_season_id: null
                    },
                    lgm_id: this.contest.data.lgm_id,
                    players: [],
                    player_data: { 'pp': player.pic, 'fn': player.fn, 'ln': player.ln },
                    player_id: player_id,
                    cache: false
                }
            });
        }
    };
    MyteamsComponent.prototype.back = function () {
        var _this = this;
        this.currentDisplay = 'left';
        this.mobileTabsIndex = 0;
        this.showStandings = false;
        setTimeout(function () {
            _this.leftSide.nativeElement.scrollTop = _this.leftScroll;
        }, 50);
    };
    MyteamsComponent.prototype.changeWeek = function () {
        var _this = this;
        this.isLoading = true;
        this.doLiveUpdate = false;
        this._myTeamsService.getContestPlayersWeek(this.contest.data.slug, this.contest.data.selectedWeek, this.selectedSeason).subscribe(function (res) {
            if (res.status) {
                var selectedWeek = _this.contest.data.selectedWeek;
                _this.contest.data = res.entities;
                _this.contest.data.selectedWeek = selectedWeek;
            }
            _this.isLoading = false;
        });
    };
    MyteamsComponent.prototype.getSwapLink = function (player, contest) {
        if (contest.data.draft_type == 4) {
            return environment.SITE_URL + "/" + environment.ANGULAR_FOLDER_NMAE + "/rankem/" + this.games[contest.data.game_id] + "/" + contest.data.league_id + "/" + contest.data.lgm_id;
        }
        else if (contest.data.draft_type == 5) {
            return environment.SITE_URL + "/drafts/tiers/" + contest.data.league_id + "/" + contest.data.lgm_id;
        }
        else {
            return environment.SITE_URL + "/player/swap-queue/" + contest.data.lg_abbr + "/" + contest.data.lg_code + "/" + player.id + "/remove/0/" + player.lgm_id + "/1";
        }
    };
    MyteamsComponent.prototype.clickMove = function (player, contest) {
        var _this = this;
        this.isLoading = true;
        this._myTeamsService.getContestPlayersMove(contest.data.slug, player.id).subscribe(function (res) {
            if (res.status) {
                _this.contest.data = res.entities;
                // console.log(this.contest.data.players);
            }
            _this.isLoading = false;
        });
    };
    // clickDrop(player, contest) {
    //   const movePlayer = contest.data.players.filter(p => p.move_undo == 1)[0];
    //   if (movePlayer) {
    //     this._myTeamsService.startMoveSession(movePlayer.id, movePlayer.gp_id, player.pick_rp, movePlayer.pick_rp, player.id, `${movePlayer.fn} ${movePlayer.ln}`, player.pick_cabbr).subscribe(res => {
    //       console.log(res);
    //     });
    //   }
    // }
    MyteamsComponent.prototype.getDropLink = function (player, contest) {
        // $lg_abbr, $lg_code, $lgm_id, $moved_player, $moved_player_pos_id, $moved_player_pos, $move_to_player_pos, $swap_outplayer, $moved_player_name, $movTo_player_compPos
        var movePlayer = contest.data.players.filter(function (p) { return p.move_undo == 1; })[0];
        return environment.SITE_URL + "/player/move-session/" + contest.data.lg_abbr + "/" + contest.data.lg_code + "/" + player.lgm_id + "/" + movePlayer.id + "/" + movePlayer.gp_id + "/" + movePlayer.pick_rp + "/" + player.pick_rp + "/" + player.id + "/" + encodeURIComponent(movePlayer.fn + ' ' + movePlayer.ln) + "/" + encodeURIComponent(movePlayer.pick_cabbr);
    };
    MyteamsComponent.prototype.confirmDrop = function (player, contest) {
        var _this = this;
        var movePlayer = contest.data.players.filter(function (p) { return p.move_undo == 1; })[0];
        var dialogRef = this.dialog.open(ConfirmDropComponent, {
            width: (this.isMobile) ? '90%' : '50%',
            data: { player: player, movePlayer: movePlayer }
        });
        dialogRef.afterClosed().subscribe(function (result) {
            if (result == 'success') {
                // redirect to move/drop
                // window.location.href = this.getDropLink(player, contest);
                _this.showPlayersForSwap(player, contest, movePlayer);
            }
        });
    };
    MyteamsComponent.prototype.showSwaps = function (player) {
        return player.is_move == 1 || player.is_swap == 1 || player.move_cnf == 1 || player.move_swap == 1 || player.move_undo == 1;
    };
    MyteamsComponent.prototype.movePlayers = function (player, contest) {
        var _this = this;
        this.isLoading = true;
        var movePlayer = contest.data.players.filter(function (p) { return p.move_undo == 1; })[0];
        this._myTeamsService.movePlayers(player.lgm_id, contest.data.league_id, movePlayer.id, player.id, this.user.id).subscribe(function (res) {
            // console.log(res);
            _this.loadContest(contest.data.slug, false, true);
        });
    };
    MyteamsComponent.prototype.contestLink = function (contest) {
        if (contest == null)
            return '';
        var lg_code = (contest.league_code != null) ? contest.league_code : contest.lg_code;
        return environment.SITE_URL + "/league/profile/" + this.games[contest.game_id] + "/" + lg_code;
    };
    MyteamsComponent.prototype.draftLink = function (contest) {
        if (contest == null)
            return '';
        return environment.SITE_URL + "/drafts/draft/" + contest.league_id;
    };
    MyteamsComponent.prototype.updateContests = function () {
        var _this = this;
        var time = Math.floor(Date.now() / 1000);
        if (this.contests.length && this.currentTab == 'live') {
            var lgms_1 = [];
            var tours_1 = [];
            this.contests.forEach(function (c) {
                if (c.type == 'league') {
                    if (c.egs < time)
                        lgms_1.push(c.lgm_id);
                }
                else {
                    if (c.egs < time) {
                        if (c.lgms != null && c.lgms.length) {
                            c.lgms.forEach(function (l) { return lgms_1.push(l.lgm_id); });
                        }
                        tours_1.push(c._id);
                    }
                }
            });
            if (lgms_1.length || tours_1.length) {
                // send lgms + tours to new endpoint for runtime updates
                this._myTeamsService.liveRefresh(lgms_1, tours_1, this.user.id).subscribe(function (res) {
                    if (res.result == 'success') {
                        _this.contests.forEach(function (c) {
                            if (c.type == 'league') {
                                if (res.uLgms[c.lgm_id] != null) {
                                    Object.keys(c).forEach(function (k) {
                                        if (res.uLgms[c.lgm_id][k] != null)
                                            c[k] = res.uLgms[c.lgm_id][k];
                                    });
                                    if (res.uLgms[c.lgm_id].display_total != null)
                                        c.team_total = res.uLgms[c.lgm_id].fpts;
                                    // if (res.uLgms[c.lgm_id].this_week != null && c.duration_id == 8) c.pmr = res.uLgms[c.lgm_id].this_week;
                                }
                            }
                            else if (c.type == 'tournament') {
                                if (res.uTours[c._id] != null) {
                                    c.best = res.uTours[c._id].rank;
                                    c.team_total = res.uTours[c._id].fpts;
                                    c.winning = res.uTours[c._id].cumulative;
                                    c.tour_entrants = res.uTours[c._id].entrants;
                                }
                                if (c.lgms.length) {
                                    c.lgms.forEach(function (l) {
                                        if (res.uLgms[l.lgm_id] != null) {
                                            Object.keys(l).forEach(function (k) {
                                                if (res.uLgms[l.lgm_id][k] != null)
                                                    l[k] = res.uLgms[l.lgm_id][k];
                                            });
                                            if (res.uLgms[l.lgm_id].display_total != null)
                                                l.team_total = res.uLgms[l.lgm_id].fpts;
                                            //if (res.uLgms[c.lgm_id].this_week != null && c.duration_id == 8) c.pmr = res.uLgms[c.lgm_id].this_week;
                                        }
                                    });
                                }
                            }
                        });
                    }
                    _this.displayContests = _this.contests;
                });
            }
        }
        // current contest update
        if (this.contest != null && this.contest.data.egs < time && this.doLiveUpdate) {
            // loadContest alternative here that only updates values and checks for changes -- trigger animations
            this._myTeamsService.getContestPlayers(this.contest.data.slug, 1, this.contest.data.lgm_id, this.selectedSeason).subscribe(function (res) {
                // console.log(res);
                if (res.status == true) {
                    _this.contest.status = 'success';
                    var updated_1 = res.entities;
                    var oldW = _this.contest.data.payout;
                    var newW = updated_1.payout;
                    if (Math.abs(oldW - newW) > 0.009) {
                        // real change
                        if (oldW > newW) {
                            _this.contest.data.winningDecrease = true;
                        }
                        else {
                            _this.contest.data.winningIncrease = true;
                        }
                    }
                    _this.contest.data.payout = newW;
                    _this.contest.data.pmr = updated_1.pmr;
                    _this.contest.data.pr = updated_1.pr;
                    _this.contest.data.team_total = updated_1.team_total;
                    _this.contest.data.players.forEach(function (p, i) {
                        if (p.id == updated_1.players[i].id) {
                            var oldV = p.fpts;
                            var newV = updated_1.players[i].fpts;
                            if (Math.abs(oldV - newV) > 0.009) {
                                // real change
                                if (oldV > newV) {
                                    p.fptsDecrease = true;
                                }
                                else {
                                    p.fptsIncrease = true;
                                }
                            }
                            p.fpts = newV;
                            p.scores = updated_1.players[i].scores;
                            p.result = updated_1.players[i].result;
                        }
                        else {
                            p = updated_1.players[i];
                        }
                    });
                    setTimeout(function () {
                        _this.contest.data.players.forEach(function (p) {
                            p.fptsDecrease = false;
                            p.fptsIncrease = false;
                        });
                        _this.contest.data.winningIncrease = false;
                        _this.contest.data.winningDecrease = false;
                    }, 4000);
                }
            });
        }
    };
    MyteamsComponent.prototype.createStatsArray = function (player, contest) {
        var _this = this;
        if (player.events.length && player.events[0].scores != null) {
            player.stats = [];
            Object.keys(player.events[0].scores).forEach(function (k) {
                if (_this.stats[k] != null && contest.sr[k] != null && player.events[0].scores[k] != 0)
                    player.stats.push({ value: player.events[0].scores[k], priority: _this.stats[k].priority, key: _this.stats[k].name });
            });
            if (player.stats.length)
                player.stats.sort(function (a, b) { return a.priority - b.priority; });
        }
    };
    MyteamsComponent.prototype.getContestType = function (contest) {
        var dt = (contest.draft_type == null) ? 1 : contest.draft_type;
        var du = (contest.duration_id == null) ? 1 : contest.duration_id;
        var draft_types = {
            1: 'Snake',
            4: 'Rank\'EM',
            5: 'Tiers',
            7: 'Cage Match'
        };
        var durations = {
            1: 'Daily',
            2: 'Weekly',
            3: 'Monthly',
            4: 'Full Season',
            5: 'Full Playoffs',
            6: 'Playoffs Round',
            7: '',
            8: 'Bestball'
        };
        if (contest.type == 'league') {
            return durations[du] + ' ' + draft_types[dt];
        }
        else {
            if (contest.is_gpp == 'Y') {
                return durations[du] + ' ' + draft_types[dt] + ' ' + 'GPP';
            }
            else {
                return 'Multi-Round';
            }
        }
    };
    MyteamsComponent.prototype.sortContests = function (type) {
        var _this = this;
        // name, type, entries, winning, fpts, place, entrants, pmr, fee
        type = type == "" ? null : type;
        if (type == this.currentSort) {
            this.currentOrder = (this.currentOrder == 'asc') ? 'desc' : 'asc';
        }
        this.currentSort = type;
        var mult = this.currentOrder == 'asc' ? 1 : -1;
        var leagueTerms = {
            'name': 'lg_name',
            'winning': 'payout',
            'fpts': 'team_total',
            'place': 'team_rank',
            'entrants': 'entrants',
            'pmr': 'pmr',
            'fee': 'lg_fee'
        };
        var tourTerms = {
            'name': 'name',
            'winning': 'winning',
            'fpts': 'team_total',
            'place': 'best',
            'entrants': 'tour_entrants',
            'pmr': 'pmr',
            'fee': 'lg_fee'
        };
        this.displayContests.sort(function (a, b) {
            if (type == 'type') {
                return _this.getContestType(a) > _this.getContestType(b) ? 1 * mult : -1 * mult;
            }
            else if (type == 'entries') {
                var first = a.type == 'league' ? 1 : a.lgm_ids.length;
                var second = b.type == 'league' ? 1 : b.lgm_ids.length;
                return first > second ? 1 * mult : -1 * mult;
            }
            else if (type == 'pmr') {
                var first = (a.pmr == null || a.duration_id == 8) ? 0 : a.pmr;
                var second = (b.pmr == null || b.duration_id == 8) ? 0 : b.pmr;
                return first > second ? 1 * mult : -1 * mult;
            }
            else if (type == 'name') {
                var first = a.type == 'league' ? a[leagueTerms[type]] : a[tourTerms[type]];
                var second = b.type == 'league' ? b[leagueTerms[type]] : b[tourTerms[type]];
                first = first.toLowerCase();
                second = second.toLowerCase();
                return first > second ? 1 * mult : -1 * mult;
            }
            else {
                var first = a.type == 'league' ? a[leagueTerms[type]] : a[tourTerms[type]];
                var second = b.type == 'league' ? b[leagueTerms[type]] : b[tourTerms[type]];
                return first > second ? 1 * mult : -1 * mult;
            }
        });
    };
    MyteamsComponent.prototype.searchContests = function () {
        var _this = this;
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(function () {
            _this.currentSort = null;
            _this.lgIndex = 0;
            _this.tIndex = 0;
            _this.leftSide.nativeElement.scrollTop = 0;
            _this.contests = [];
            _this.displayContests = [];
            _this.loadingContests = true;
            _this.loadContests();
        }, 750);
    };
    MyteamsComponent.prototype.setType = function (type) {
        this.contestFilters = type;
        this.lgIndex = 0;
        this.tIndex = 0;
        this.leftSide.nativeElement.scrollTop = 0;
        this.contests = [];
        this.displayContests = [];
        this.loadingContests = true;
        this.loadContests();
    };
    MyteamsComponent.prototype.setSeason = function (value) {
        this.selectedSeason = value;
        this.lgIndex = 0;
        this.tIndex = 0;
        this.leftSide.nativeElement.scrollTop = 0;
        this.contests = [];
        this.displayContests = [];
        this.loadingContests = true;
        this.loadContests();
    };
    MyteamsComponent.prototype.clearSearch = function () {
        this.contestSearch = '';
        this.searchContests();
    };
    MyteamsComponent.prototype.getCurrentlyWinning = function () {
        return this.contests.reduce(function (acc, e) {
            if (e.type == 'league') {
                acc += parseFloat(e.payout);
            }
            else {
                acc += parseFloat(e.winning);
            }
            return acc;
        }, 0);
    };
    MyteamsComponent.prototype.showEntrants = function (contest, lgm) {
        if (contest == null || lgm == null || contest.data == null)
            return '';
        if (contest.data._tour_id > 0 && contest.data.is_gpp == 'N') {
            // Multi-Round Tournament
            return (this.mrFullStandings) ? lgm.tour_entrants : lgm.entrants;
        }
        else {
            return (this.contest.data._tour_id > 0) ? lgm.tour_entrants : lgm.entrants;
        }
    };
    MyteamsComponent.prototype.showRank = function (contest, lgm) {
        var _this = this;
        if (contest == null || lgm == null || contest.data == null)
            return '';
        if (contest.data._tour_id > 0 && contest.data.is_gpp == 'N') {
            // Multi-Round Tournament
            var count = this.standings.reduce(function (acc, o) {
                if (_this.mrFullStandings) {
                    if (o.tour_rank == lgm.tour_rank)
                        acc++;
                }
                else {
                    if (o.team_rank == lgm.team_rank)
                        acc++;
                }
                return acc;
            }, 0);
            if (count > 1)
                lgm.is_tie == 'Y';
            return (this.mrFullStandings) ? lgm.tour_rank : lgm.team_rank;
        }
        else {
            return (this.contest.data._tour_id > 0) ? lgm.tour_rank : lgm.team_rank;
        }
    };
    MyteamsComponent.prototype.printPlayerName = function (player) {
        // (isMobile)?player.fn.substr(0,1)+'.':player.fn}} {{player.ln}}
        if (player.gp_id == 16)
            return player.fn;
        return (this.isMobile) ? player.fn.substr(0, 1) + ". " + player.ln : player.fn + " " + player.ln;
    };
    MyteamsComponent.prototype.matchPlayersHeight = function (current) {
        //console.log('matchPlayersHeight', this.playersContainer);
        if (this.playersContainer != null && this.playersContainer.length) {
            // console.log(this.playersContainer.first);
            return this.playersContainer.first.nativeElement.clientHeight;
        }
        else {
            return this.getHeight(current);
        }
    };
    MyteamsComponent.prototype.showMobStats = function (player) {
        if (this.isMobile) {
            if (player.showStats != null) {
                player.showStats = !player.showStats;
            }
            else {
                player.showStats = true;
            }
        }
    };
    MyteamsComponent.prototype.mobileTabsChange = function (e, contest) {
        switch (e.index) {
            case 0:
                this.standingsOff();
                break;
            case 1:
                if (!this.showStandings)
                    this.startStandings();
                break;
            case 2:
                window.location.href = this.contestLink(contest);
                break;
            case 3:
                window.location.href = this.draftLink(contest);
                break;
        }
        ;
    };
    MyteamsComponent.prototype.fptsText = function (contest, player) {
        if (contest.draft_type != 4) {
            return contest.fptsText;
        }
        else {
            return Math.floor(Math.round((player.fpts / player.pn) * 100)) / 100 + " " + contest.fptsText;
        }
    };
    MyteamsComponent.prototype.openLeague = function (league_id, tournament_id) {
        var dialogRef = null;
        if (tournament_id == 0) {
            dialogRef = this.dialog.open(GamepreviewpopupComponent, {
                width: '800px',
                data: { league_id: league_id },
                autoFocus: false
            });
        }
        else {
            var remaining_people = 0;
            dialogRef = this.dialog.open(TournamentpopupComponent, {
                width: '800px',
                data: {
                    league_id: league_id,
                    tournament_id: tournament_id,
                    remaining_people: remaining_people
                },
                autoFocus: false
            });
        }
        dialogRef.afterClosed().subscribe(function (result) {
            // console.log(result);
        });
    };
    MyteamsComponent.prototype.weekMatrix = function (lgmData) {
        var dialogRef = null;
        var width1 = (this.isMobile) ? '100%' : '90%';
        var width2 = (this.isMobile) ? '100%' : '50%';
        dialogRef = this.dialog.open(WeekMetrixComponent, {
            width: (lgmData.weekSlider.length > 5) ? width1 : width2,
            data: { lgmData: lgmData },
            autoFocus: false
        });
        dialogRef.afterClosed().subscribe(function (result) { });
    };
    MyteamsComponent.prototype.matchUp = function (lgmData) {
        var dialogRef = null;
        dialogRef = this.dialog.open(MatchupComponent, {
            width: (this.isMobile) ? '100%' : '90%',
            data: { lgmData: lgmData },
            autoFocus: false
        });
        dialogRef.afterClosed().subscribe(function (result) { });
    };
    MyteamsComponent.prototype.downloadImage = function () {
        var _this = this;
        this.showCanvasSS = true;
        this.isLoading = true;
        setTimeout(function () {
            html2canvas(_this.screenToCapture.nativeElement, { scale: 2, allowTaint: false, useCORS: true, backgroundColor: _this.darkMode ? "#0E1523" : "#f5f5f5" }).then(function (canvas) {
                _this.downloadLinkForSS.nativeElement.href = canvas.toDataURL("image/png");
                _this.canvasForSS.nativeElement.src = canvas.toDataURL("image/png");
                _this.downloadLinkForSS.nativeElement.download = "My-Team.png";
                _this.downloadLinkForSS.nativeElement.click();
                _this.showCanvasSS = false;
                _this.isLoading = false;
            });
        }, 1000);
    };
    MyteamsComponent.prototype.getURL = function (players) {
        return __awaiter(this, void 0, void 0, function () {
            var newImg, chunks, i, chunk, k;
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, true];
            });
        });
    };
    MyteamsComponent.prototype.prettyPrint = function (number) {
        var rem = number % 100;
        if (rem > 10 && rem < 21) {
            return number + 'th';
        }
        else {
            var rem2 = number % 10;
            if (rem2 == 1)
                return number + 'st';
            if (rem2 == 2)
                return number + 'nd';
            if (rem2 == 3)
                return number + 'rd';
            return number + 'th';
        }
    };
    MyteamsComponent.prototype.setupListeners = function (type) {
        var _this = this;
        // active drafts emit (active_draft)
        this._resultboardService.emitActiveDraft({
            user_id: this.user.id,
            is_app: 1,
            is_connect: 1
        });
        if (this.activeDraftListener)
            this.activeDraftListener.unsubscribe();
        this.activeDraftListener = this._resultboardService.listActiveDraft().subscribe(function (r) {
            if (r.status == 1) {
                _this.displayActiveContests = r.entities;
                var fastd = _this.displayActiveContests.filter(function (ad) { return ad.pick_time < 600; });
                var slowd = _this.displayActiveContests.filter(function (ad) { return ad.pick_time >= 600; });
                slowd.sort(function (a, b) {
                    return a.order_key - b.order_key;
                });
                _this.displayActiveContests = fastd.concat(slowd);
                if (_this.displayActiveContests.length > 0 && type == 'init') {
                    _this.currentTab = 'drafting';
                }
                _this.startTimers();
                _this._resultboardService.activeDraftVisibleEmit((_this.displayActiveContests.length) > 0);
            }
        });
        if (this.newLeague)
            this.newLeague.unsubscribe();
        this.newLeague = this._resultboardService.getNewActiveLeague().subscribe(function (r) {
            r.entities.status = 1;
            _this.displayActiveContests.push(r.entities);
            _this._resultboardService.activeDraftVisibleEmit((_this.displayActiveContests.length) > 0);
        });
        if (this.pickChanges)
            this.pickChanges.unsubscribe();
        this.pickChanges = this._resultboardService.pickChanges().subscribe(function (r) {
            if (_this.displayActiveContests != null) {
                var selected_1;
                selected_1 = _this.displayActiveContests.filter(function (l) { return l.league_id == r.entities.active_draft.league_id; });
                if (selected_1.length) {
                    selected_1 = selected_1[0];
                    Object.keys(r.entities.active_draft).forEach(function (k) {
                        selected_1[k] = r.entities.active_draft[k];
                    });
                    if (selected_1.status == 4) {
                        if (selected_1.timer != null)
                            clearInterval(selected_1.timer);
                        setTimeout(function () {
                            var index = -1;
                            _this.displayActiveContests.forEach(function (l, i) {
                                if (l.league_id == selected_1.league_id)
                                    index = i;
                            });
                            if (index > -1)
                                _this.displayActiveContests.splice(index, 1); // remove completed
                            _this._resultboardService.activeDraftVisibleEmit((_this.displayActiveContests.length) > 0);
                        }, 10000);
                    }
                    _this.startTimers();
                }
                _this._resultboardService.activeDraftVisibleEmit((_this.displayActiveContests.length) > 0);
            }
        });
    };
    MyteamsComponent.prototype.showMessage = function (league) {
        return (league.status != 1) ? league.msg : 'Pre-Draft';
    };
    MyteamsComponent.prototype.isMyPick = function (league) {
        return (league.pick_status == 1 || league.status == 1) && league.is_active == 1 && (league.is_paused == 'N' || league.is_paused == 0);
    };
    MyteamsComponent.prototype.startTimers = function () {
        var _this = this;
        this.displayActiveContests.forEach(function (l) {
            if (l.timer != null)
                clearInterval(l.timer);
            if (l.is_active == 1 && (l.is_paused == 'N' || l.is_paused == 0)) {
                l.time_left--;
                l.timer = setInterval(function () {
                    l.time_left--;
                    l.clock = _this.getPickClock(l.time_left);
                    l.width = Math.floor((l.time_left / l.pick_time) * 100) + '%';
                    if (l.time_left <= 0)
                        clearInterval(l.timer);
                }, 1000);
            }
        });
    };
    MyteamsComponent.prototype.getPickClock = function (timeleft) {
        if (timeleft > 60 * 60 * 24) {
            var days = Math.floor(timeleft / (60 * 60 * 24));
            return days + " " + (days > 1 ? 'days' : 'day');
        }
        else if (timeleft > 60 * 60) {
            var hours = Math.floor(timeleft / (60 * 60));
            var minutes = Math.floor(timeleft / 60) % 60;
            var seconds = timeleft % 60;
            return this.tp(hours) + ":" + this.tp(minutes) + ":" + this.tp(seconds);
        }
        else {
            var minutes = Math.floor(timeleft / 60);
            var seconds = timeleft % 60;
            return this.tp(minutes) + ":" + this.tp(seconds);
        }
    };
    MyteamsComponent.prototype.tp = function (val) {
        return (val.toString().length == 1) ? "0" + val : "" + val;
    };
    MyteamsComponent.prototype.showPlayersForSwap = function (player, contest, movePlayer) {
        var _this = this;
        if (movePlayer === void 0) { movePlayer = null; }
        if (contest.data.draft_type == 4) {
            // let url = `${environment.SITE_URL}/${environment.ANGULAR_FOLDER_NMAE}/rankem/${this.games[contest.data.game_id]}/${contest.data.league_id}/${contest.data.lgm_id}`;
            var url = "/rankem/" + this.games[contest.data.game_id] + "/" + contest.data.league_id + "/" + contest.data.lgm_id;
            this.router.navigate([url]);
        }
        else if (contest.data.draft_type == 5) {
            var url = "/tiers/" + contest.data.league_id + "/" + contest.data.lgm_id;
            this.router.navigate([url]);
        }
        else {
            var dialogRef = null;
            dialogRef = this.dialog.open(SwapPlayersComponent, {
                width: (this.isMobile) ? '100%' : '50%',
                data: {
                    player: player,
                    movePlayer: movePlayer,
                    league: {
                        game_id: this.contest.data.game_id,
                        id: this.contest.data.league_id,
                        abbr: this.games[this.contest.data.game_id],
                        active_season_id: null,
                        leagueData: this.contest.data
                    },
                },
                autoFocus: false
            });
            dialogRef.afterClosed().subscribe(function (result) {
                if (result.status == 'success') {
                    _this.loadContest(result.league_member_slug, false, true);
                    if (result.multiSwap && movePlayer == null) {
                        _this._myTeamsService.getMultiSwapLeagues(result.multiSwap).subscribe(function (res) {
                            result.leaguesList = res.entities;
                            if (result.leaguesList.length > 0) {
                                var dialogRef_1 = null;
                                result.type = 'mlswap';
                                dialogRef_1 = _this.dialog.open(MultiSwapPlayersComponent, {
                                    width: (_this.isMobile) ? '100%' : '50%',
                                    data: result,
                                    autoFocus: false
                                });
                                dialogRef_1.afterClosed().subscribe(function (leagueToRedirect) {
                                    if (leagueToRedirect.league_member_slug)
                                        _this.loadContest(leagueToRedirect.league_member_slug, false, true);
                                });
                            }
                            else {
                                _this._myTeamsService.getOtherLeaguesForMultiSwap(result.multiSwap).subscribe(function (res) {
                                    result.leaguesList = res.entities;
                                    if (result.leaguesList.length > 0) {
                                        var dialogRef_2 = null;
                                        result.type = 'mlinfo';
                                        dialogRef_2 = _this.dialog.open(MultiSwapPlayersComponent, {
                                            width: (_this.isMobile) ? '100%' : '50%',
                                            data: result,
                                            autoFocus: false
                                        });
                                        dialogRef_2.afterClosed().subscribe(function (leagueToRedirect) {
                                            if (leagueToRedirect.league_member_slug)
                                                _this.loadContest(leagueToRedirect.league_member_slug, false, true);
                                        });
                                    }
                                });
                            }
                        });
                    }
                }
                else if (result.status == 'failure' || result.status == "started") {
                    _this.errorMsg = result.message;
                    setTimeout(function () {
                        _this.errorMsg = '';
                    }, 5000);
                }
            });
        }
    };
    MyteamsComponent.prototype.openLgBoard = function (lgId, tourId) {
        this.lgId = lgId;
        this.tourId = tourId;
        this.showLgBoard = true;
    };
    MyteamsComponent.prototype.getRGBAColor = function (color) {
        return 'rgba(' + parseInt('0x' + color.substr(1, 2), 16) + ',' + parseInt('0x' + color.substr(3, 2), 16) + ',' + parseInt('0x' + color.substr(5, 2), 16) + ',' + color.substr(8) + ')';
    };
    MyteamsComponent.prototype.confirmDialog = function (e, league_code, league_name, seconds_per_pick, tournament_id) {
        var _this = this;
        e.preventDefault();
        this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
            width: '500px',
            data: { 'title': league_name, 'body': 'Are you sure you want to leave this league?', 'type': 'confirm_popup' }
        });
        this.confirmDialogRef.afterClosed()
            .subscribe(function (res) {
            if (res) {
                _this.leaveLeague(league_code, seconds_per_pick, tournament_id);
            }
        });
    };
    MyteamsComponent.prototype.leaveLeague = function (league_code, seconds_per_pick, tournament_id) {
        var _this = this;
        if (seconds_per_pick === void 0) { seconds_per_pick = 0; }
        if (tournament_id === void 0) { tournament_id = 0; }
        this.isLoading = true;
        this.sub_result = this.tournamentService.draftLeaveLeagueRequest({ league_code: league_code, seconds_per_pick: seconds_per_pick, tournament_id: tournament_id }).subscribe(function (res) {
            if (typeof res !== 'undefined' && res.status === 'success') {
                var updated_balance = (res.entities != null && res.entities.updated_balance != null) ? res.entities.updated_balance : '0';
                _this.store.dispatch(new UserBalanceData(updated_balance));
                _this.isLoading = false;
                _this.tabChange('upcoming');
            }
            else {
                _this.errorMsg2 = res.message;
                setTimeout(function () {
                    _this.errorMsg2 = '';
                }, 10000);
                _this.isLoading = false;
                _this.tabChange('upcoming');
            }
        });
    };
    return MyteamsComponent;
}());
export { MyteamsComponent };
